import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from './firebase'; 
import CustomButton from './Components/Buttons'; 
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ProfileOverlay from './Components/ProfileOverlay';

function SurveyProfilePage() {
  const [profiles, setProfiles] = useState([]);
  const [selectedProfile, setSelectedProfile] = useState(null); 
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isOverlayVisible, setOverlayVisible] = useState(false);

  const handleOverlayToggle = () => {
    setOverlayVisible(!isOverlayVisible); 
  };

  const handleOverlayClose = () => {
    setOverlayVisible(false); 
    setSelectedProfile(null); 

  };

  const handleProfileClick = (profile) => {
    setSelectedProfile({data: profile}); 
    console.log(selectedProfile); 
    setOverlayVisible(true); 
  };

  useEffect(() => {
    const fetchProfiles = async () => {
      try {
        const profileCollection = collection(db, 'profile');
        const profileSnapshot = await getDocs(profileCollection);
        const profileList = profileSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setProfiles(profileList);
      } catch (error) {
        console.error('Error fetching profiles:', error);
      }
    };

    fetchProfiles();
  }, []);

  return (
    <div>
      <h2 style={{ margin: '10px', fontFamily: 'KomikaAxis', color: 'var(--primary-color)'}}>{t('profileSelect')}</h2>
      <div style={{display: 'flex', flexDirection: 'row', gap: '10px', justifyContent: 'center'}}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', flexDirection: 'column', gap: '10px' }}> 
        {profiles.map(profile => (
          <CustomButton
            key={profile.id}
            label={profile.name}
            type="secondary"
            onClick={() => handleProfileClick(profile)} 
          />
        ))}
        {selectedProfile && (
          <ProfileOverlay 
            isVisible={isOverlayVisible}
            profile={selectedProfile}
            onClose={handleOverlayClose}
          />
        )}
      </div>
      <div style={{display: 'flex', alignItems: 'flex-start'}}>
      <CustomButton
          label={t('newProfile')}
          
          type="default"
          onClick={() => navigate(`/survey`)} 
          style={{margin: '50px', fontSize: '16px', height: '50px'}}
        />
        </div>
    </div>
    </div>
  );
}

export default SurveyProfilePage;